import {
    useMutation,
    UseMutationOptions,
    useQuery,
    useQueryClient,
    UseQueryOptions,
} from "@tanstack/react-query";
import { useAccessToken, useStandardErrorHandler } from "modules/common";
import { toast } from "react-toastify";
import {
    getMobileApps,
    createMobileApp,
    GetMobileAppRequest,
    MobileAppPaginatedResponse,
    CreateMobileAppRequest,
    editMobileApp,
    EditMobileAppRequest,
    deleteMobileApp,
    MobileApp as MobileAppEntry,
} from "services/mobileAppsPortal";

export const useGetMobileApps = (
    data: GetMobileAppRequest,
    options?: UseQueryOptions<MobileAppPaginatedResponse>
) => {
    const errorHandler = useStandardErrorHandler("Greška pri dohvaćanju mobilnih aplikacija");
    const accessToken = useAccessToken();
    const { enabled, ...opts } = options ?? {};
    const queryFn = () => getMobileApps(data, accessToken!);

    return useQuery({
        queryKey: ["mobileApps", data],
        queryFn,
        onError: errorHandler,
        ...opts,
    });
};

export const useCreateMobileApp = (
    uploadedFile: File | null,
    options?: UseMutationOptions<MobileAppEntry, unknown, CreateMobileAppRequest>
) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const errorHandler = useStandardErrorHandler("Greška pri stvaranju aplikacije");
    
    return useMutation({
        mutationFn: (data: CreateMobileAppRequest) =>
            createMobileApp(data, uploadedFile, accessToken!),
        onError: errorHandler,
        onSuccess: () => {
            queryClient.invalidateQueries(["mobileApps"]);
            toast.success("Aplikacija je uspješno stvorena");
        },
        ...options,
    });
};

export const useEditMobileApp = (uploadedFile: File | null) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const errorHandler = useStandardErrorHandler("Greška pri uređivanju edukacijskog dokumenta");

    return useMutation({
        mutationFn: (data: EditMobileAppRequest) =>
            editMobileApp(data, uploadedFile, accessToken!),
        onError: errorHandler,
        onSuccess: () => {
            queryClient.invalidateQueries(["mobileApps"]);
            toast.success("Aplikacija je uspješno uređena.");
        },
    });
};

export const useDeleteMobileApp = (
    
) => {
    const accessToken = useAccessToken();
    const queryClient = useQueryClient();
    const errorHandler = useStandardErrorHandler("Greška pri brisanju mobilne aplikacije");

    return useMutation({
        mutationFn: (guid: string) => deleteMobileApp(guid, accessToken!),
        onError: errorHandler,
        onSuccess: () => {
            queryClient.invalidateQueries(["mobileApps"]);
            toast.success("Mobilna aplikacija je uspješno obrisana");
        },
    });
};